import { Box, Divider, Link, Typography } from "@mui/material";
import CategorySlider from "../../../../components/guest/Aside/Categories";
import Testimonials from "../../../../components/guest/Aside/Testimonials";
import PopularPosts from "../../../../components/guest/Aside/Popular";
import SkeletonImage from "../../../../components/ui/SkeletonImage";
import { Link as NavLink } from "react-router-dom";
import Images from "../../../../assets/js/Images";
import { Fragment } from "react";

function Aside({ ...props }) {
  const { blog } = props;

  return (
    <Fragment>
      <Box>
        <Typography
          fontSize={28}
          fontWeight="700"
          textAlign="center"
          color="other.color1"
        >
          Categories
        </Typography>
        <Divider
          sx={{
            mt: 2,
            mb: 5,
            mx: "auto",
            maxWidth: "200px",
            borderWidth: "1.5px",
            borderColor: "secondary.main",
          }}
        />
        <CategorySlider />
      </Box>

      <Box>
        <Typography
          fontSize={28}
          fontWeight="700"
          textAlign="center"
          color="other.color1"
        >
          Popular Posts
        </Typography>
        <Divider
          sx={{
            mt: 2,
            mb: 5,
            mx: "auto",
            maxWidth: "200px",
            borderWidth: "1.5px",
            borderColor: "secondary.main",
          }}
        />
        <PopularPosts />
      </Box>

      <Box>
        <Typography
          fontSize={28}
          fontWeight="700"
          textAlign="center"
          color="other.color1"
        >
          Testimonials
        </Typography>
        <Divider
          sx={{
            mt: 2,
            mb: 5,
            mx: "auto",
            maxWidth: "200px",
            borderWidth: "1.5px",
            borderColor: "secondary.main",
          }}
        />
        <Testimonials />
      </Box>

      <Box>
        {blog?.tags?.length > 0 && (
          <>
            {" "}
            <Typography
              fontSize={28}
              fontWeight="700"
              textAlign="center"
              color="other.color1"
            >
              Tag Cloud
            </Typography>
            <Divider
              sx={{
                mt: 2,
                mb: 5,
                mx: "auto",
                maxWidth: "200px",
                borderWidth: "1.5px",
                borderColor: "secondary.main",
              }}
            />
            <Box
              sx={{
                gap: 1,
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              {blog?.tags?.map((tag, i) => (
                <Link
                  key={i}
                  sx={{
                    px: 1.5,
                    py: 0.5,
                    fontSize: "15px",
                    fontWeight: "500",
                    bgcolor: "white",
                    whiteSpace: "nowrap",
                    color: "other.color2",
                    display: "inline-block",
                    transition: "all 400ms ease",
                    ":hover": {
                      color: "white",
                      bgcolor: "secondary.dark",
                    },
                  }}
                  underline="none"
                  component={NavLink}
                >
                  {tag}
                </Link>
              ))}
            </Box>
          </>
        )}

        <Box
          sx={{
            mt: 5,

            aspectRatio: "1/0.9",
          }}
        >
          <Link
            sx={{
              height: "100%",
              display: "inline-block",
              width: "100%",
              margin: "auto",
            }}
            component={NavLink}
            to="/help-center"
          >
            <SkeletonImage
              sx={{
                objectFit: "contain",
              }}
              src={Images.asideContactus}
            />
          </Link>
        </Box>
      </Box>
    </Fragment>
  );
}

export default Aside;
